import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InputComponent, ButtonComponent, ToastService } from '@/shared/components';
import { AuthService } from '@/services/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule, ButtonComponent],
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit {
  email = '';
  code = '';
  newPassword = '';
  confirmPassword = '';
  isLoading = false;
  submitted = false;
  showPassword = false;
  showConfirmPassword = false;
  successMessage = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {
    // Get email and code from navigation state
    const navigation = this.router.getCurrentNavigation();
    this.email = navigation?.extras?.state?.['email'] || '';
    this.code = navigation?.extras?.state?.['code'] || '';
  }

  ngOnInit() {
    // If no email or code, redirect back to forgot password
    if (!this.email || !this.code) {
      this.router.navigate(['/recuperar-senha']);
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit() {
    this.submitted = true;

    if (!this.isValid()) {
      return;
    }

    this.isLoading = true;

    this.authService.resetPassword(this.email, this.code, this.newPassword).subscribe({
      next: () => {
        this.isLoading = false;
        this.successMessage = true;

        // Auto-login after password reset
        setTimeout(() => {
          this.authService.login({ email: this.email, password: this.newPassword }).subscribe({
            next: (response) => {
              // Get user role and redirect to appropriate page
              const user = this.authService.getCurrentUser();
              if (user) {
                const redirectPath = this.authService.getRedirectPath(user.role);
                this.router.navigate([redirectPath]);
              } else {
                this.router.navigate(['/portal']);
              }
            },
            error: (error) => {
              console.error('Auto-login failed:', error);
              const errorMessage = error.error?.message || 'Erro ao fazer login';
              this.toastService.error(errorMessage);
              // If auto-login fails, just redirect to login
              this.router.navigate(['/login']);
            }
          });
        }, 2000);
      },
      error: (error) => {
        console.error('Error resetting password:', error);
        this.isLoading = false;
        const errorMessage = error.error?.message || 'Erro ao redefinir senha. Tente novamente.';
        this.toastService.show('error', errorMessage);
      }
    });
  }

  isValid(): boolean {
    return (
      this.newPassword.length >= 6 &&
      this.newPassword === this.confirmPassword
    );
  }
}
